import { Text, Flex, Link } from "@chakra-ui/react";
import { t } from "i18next";
import { FUNNEL_TYPES } from "../../funnel/utils/contants";
import { FunnelComponentProps } from "../../funnel/types";
import { SignUpWithEmailPasswordForm } from "./SignUpWithEmailPasswordForm";
import { TermsSection } from "./TermsSection";

export function SignUpWithEmailPasswordModalFooter({
  setFunnelType,
}: FunnelComponentProps) {
  return (
    <Flex padding="24px" justifyContent="center">
      <Text fontSize="sm" color="neutral.400" align="center">
        {t("components.auth.alreadyHaveAnAccount")}{" "}
        <Link
          color="neutral.200"
          textDecoration="underline"
          onClick={() => {
            setFunnelType(FUNNEL_TYPES.login);
          }}
        >
          {t("components.auth.login")}
        </Link>
      </Text>
    </Flex>
  );
}

export function SignUpWithEmailPasswordModalBody({
  onSuccess,
  invalidate = true,
  loading = false,
  loadingText,
  autoFocus,
}: FunnelComponentProps & {
  invalidate?: boolean;
  loading?: boolean;
  loadingText?: string;
  autoFocus?: boolean;
}) {
  return (
    <Flex direction="column" width="100%" padding="24px">
      <SignUpWithEmailPasswordForm
        onSuccess={onSuccess}
        invalidate={invalidate}
        loading={loading}
        loadingText={loadingText}
        autoFocus={autoFocus}
      />
      <TermsSection />
    </Flex>
  );
}
